import isProduction from '../utils/helpers/isProduction'

export const devUrl = isProduction()
  ? 'https://api.flexxi.care/'
  : 'https://api.flexxi.dev.swiftech.am/'
